<template>
    <div>
        <div class="ix-page-header js-ix-page-header">
            <div class="container-fluid">
                <div class="ix-page-header-content">
                    <div class="ix-page-header-left">
                        <h1 class="ix-page-header-title">Indicateurs</h1>
                    </div>

                    <div class="ix-page-header-right">
                        <button class="ix-btn ix-page-header-action blue" @click="savePreferences()">
                            <span v-if="loadingPreferences">
                                <i class="far fa-circle-notch fa-spin"></i>
                            </span>
                            <span v-if="!loadingPreferences">
                                <i class="far fa-save"></i> Sauvegarder les indicateurs à afficher
                            </span>
                        </button>

                       <!-- <div class="dropdown d-inline-block need-selection">
                            <button class="ix-btn ix-page-header-action dropdown-toggle" v-if="table.rows.length > 0" :disabled="loadingTxt" type="button" id="dropdownMenuButton"  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <span v-if="loadingTxt">
                                        <i class="far fa-circle-notch fa-spin"></i> Préparation du fichier
                                    </span>
                                    <span v-if="!loadingTxt">
                                        <i class="far fa-arrow-to-bottom"></i> Fichier de calcul
                                    </span>
                            </button>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                    <button class="dropdown-item" @click="downloadIndicator('indicators_v2.txt', 'tec')"><i class="fas fa-wrench"></i> Travaux en cours</button>
                                    <button class="dropdown-item" @click="downloadIndicator('indicator_margins_consolidated.txt', 'marge_consolidée')"><i class="fas fa-tachometer"></i> Marge consolidée de la période</button>
                                    <button class="dropdown-item" @click="downloadIndicator('indicator_margins_forecast.txt', 'marge_prévisionelle')"><i class="fas fa-tachometer"></i> Marge prévisionnelle de la période</button>
                            </div>
                        </div>-->

                         <div class="dropdown d-inline-block need-selection" v-if="table.rows.length > 0" >
                            <button class="ix-btn ix-btn-icon ix-page-header-action dropdown-toggle"  type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <span v-if="loadingTxt">
                                        <i class="far fa-circle-notch fa-spin"></i> Préparation du fichier
                                    </span>
                                    <span v-if="!loadingTxt">
                                        <i class="far fa-file-export"></i>
                                    </span>
                            </button>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                <button class="dropdown-item" @click="exportExcelIndicator()">Tout exporter</button>
                                <button class="dropdown-item" @click="downloadIndicator('tec')">Export TEC</button>
                            </div>
                        </div>

                        <button class="ix-btn ix-btn-icon ix-page-header-action" title="Télécharger" v-if="table.rows.length > 0" @click="download()" :disabled="loadingDownload">
                            <span v-if="loadingDownload">
                                <i class="far fa-circle-notch fa-spin"></i> Préparation du fichier
                            </span>
                            <span v-if="!loadingDownload">
                                <i class="far fa-arrow-to-bottom"></i>
                            </span>
                        </button>
                        <button class="ix-btn ix-page-header-action" @click="openIndicatorSelectionModal()"><i class="far fa-check-square"></i> Indicateurs à afficher</button>
                    </div>
                </div>
            </div>
        </div>  

        
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <div class="form-group">
                        <label for="filters_view">Format du tableau</label>
                        <select v-model="filters.view" class="form-control" id="filters_view" @change="viewFilterChanged">
                            <option :value="view.value" v-for="(view, index) in filters.views" v-bind:key="index">{{ view.label }}</option>
                        </select>
                    </div>
                </div>

                <div class="col-sm-12 col-md-6 col-lg-3">
                    <div class="form-group">
                        <label for="filters_year">Année</label>
                        <select v-model="filters.year" class="form-control" id="filters_year" @change="yearFilterChanged">
                            <option :value="year" v-for="(year, index) in filters.years" v-bind:key="index">{{ year.year }}</option>
                        </select>
                    </div>
                </div>

                <div class="col-sm-12 col-md-6 col-lg-3" v-if="filters.year" v-show="filters.view == 'w'">
                    <div class="form-group">
                        <label for="filters_week">Semaine</label>
                        <select v-model="filters.week" class="form-control" id="filters_week" @change="weekFilterChanged">
                            <option :value="n" v-for="n in filters.year.max_week">Semaine {{ n }}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="row" v-if="closeMessage != null">
                <div class="col-sm-12">
                    <div class="alert alert-success">{{ closeMessage }}</div>
                </div>
            </div>


            <div class="row">
                 <div class="col-sm-12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="filters_show_description" v-model="filters.show_description">
                            <label class="form-check-label" for="filters_show_description">Afficher la description des indicateurs</label>
                        </div>
                    </div>
                </div>
            </div>


            <div class="row mt-4">
                <div class="col-sm-12">
                    <div class="ix-table-box">
                        <table class="ix-table ix-table-sm ix-table-hoverable ix-table-bordered">
                            <thead v-if="table.header.length > 0">
                                <tr>
                                    <th></th>
                                    <th v-for="(head, index) in table.header" v-bind:key="index" class="text-center">{{ head.label }}</th>
                                    <th class="text-center">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                              
                                <tr class="ix-table-row-secondary text-center" v-if="filteredTable(groupBy.crm).length > 0 && showRowIndicator(filteredTable(groupBy.crm)[0])">
                                    <th :colspan="table.header.length + 2"  @click="showGroup.crm = !showGroup.crm"  class="ix-row-header">
                                        CRM
                                        <span class="text-right ml-2">
                                                <i class="fas fa-chevron-down" v-if="showGroup.crm"></i>
                                                <i class="fas fa-chevron-up" v-if="!showGroup.crm"></i>
                                        </span>
                                    </th>
                                </tr>
                                <tr v-for="(row, index) in table.rows" v-bind:key="index" v-if="showRowIndicator(row) && showGroup.crm && row.group == groupBy.crm">
                                    <td>
                                        {{ row.label }} 
                                        <br>
                                        <small v-if="filters.show_description">
                                            {{ row.description }}
                                        </small>
                                    </td>
                                    <td v-for="(head, index) in table.header" v-bind:key="index" class="text-center">
                                        <span v-if="row.data[head.index] != null">
                                        
                                            <span v-if="row.unit != 'euros'">{{ row.data[head.index] }}{{ row.unit == 'percent' ? '%' : '' }}</span>
                                            <span v-if="row.unit == 'euros'">{{ currency(row.data[head.index]) }}</span>
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <span v-if="row.total != null">
                                            <span v-if="row.unit != 'euros'">{{ row.total }}{{ row.unit == 'percent' ? '%' : '' }}</span>
                                            <span v-if="row.unit == 'euros'">{{ currency(row.total) }}</span>
                                        </span>
                                    </td>
                                </tr>
                                <tr class="ix-table-row-secondary text-center" v-if="filteredTable(groupBy.activity).length > 0 && showRowIndicator(filteredTable(groupBy.activity)[0])">
                                    <th :colspan="table.header.length + 2"  @click="showGroup.activity = !showGroup.activity"  class="ix-row-header">
                                        Activité
                                        <span class="text-right ml-2">
                                                <i class="fas fa-chevron-down" v-if="showGroup.activity"></i>
                                                <i class="fas fa-chevron-up" v-if="!showGroup.activity"></i>
                                        </span>
                                    </th>
                                </tr>
                                <tr v-for="(row, index) in table.rows" v-bind:key="index" v-if="showRowIndicator(row) && showGroup.activity && row.group == groupBy.activity">
                                    <td>
                                        {{ row.label }}
                                        <br>
                                        <small v-if="filters.show_description">
                                            {{ row.description }}
                                        </small>
                                    </td>
                                    <td v-for="(head, index) in table.header" v-bind:key="index" class="text-center">
                                        <span v-if="row.data[head.index] != null">
                                        
                                            <span v-if="row.unit != 'euros'">{{ row.data[head.index] }}{{ row.unit == 'percent' ? '%' : '' }}</span>
                                            <span v-if="row.unit == 'euros'">{{ currency(row.data[head.index]) }}</span>
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <span v-if="row.total != null">
                                            <span v-if="row.unit != 'euros'">{{ row.total }}{{ row.unit == 'percent' ? '%' : '' }}</span>
                                            <span v-if="row.unit == 'euros'">{{ currency(row.total) }}</span>
                                        </span>
                                    </td>
                                </tr>
                                            
                                <tr class="ix-table-row-secondary text-center" v-if="filteredTable(groupBy.trade).length > 0 && showRowIndicator(filteredTable(groupBy.trade)[0])">
                                    <th :colspan="table.header.length + 2" @click="showGroup.trade = !showGroup.trade" class="ix-row-header" slot="header">
                                        Commerce
                                        <span class="text-right ml-2">
                                                <i class="fas fa-chevron-down" v-if="showGroup.trade"></i>
                                                <i class="fas fa-chevron-up" v-if="!showGroup.trade"></i>
                                        </span>
                                    </th>
                                </tr>

                                <tr v-for="(row, index) in table.rows" v-bind:key="index" v-if="showRowIndicator(row) && showGroup.trade && row.group == groupBy.trade">
                                    <td>
                                        {{ row.label }}
                                        <br>
                                        <small v-if="filters.show_description">
                                            {{ row.description }}
                                        </small>
                                    </td>
                                    <td v-for="(head, index) in table.header" v-bind:key="index" class="text-center">
                                        <span v-if="row.data[head.index] != null">
                                        
                                            <span v-if="row.unit != 'euros'">{{ row.data[head.index] }}{{ row.unit == 'percent' ? '%' : '' }}</span>
                                            <span v-if="row.unit == 'euros'">{{ currency(row.data[head.index]) }}</span>
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <span v-if="row.total != null">
                                            <span v-if="row.unit != 'euros'">{{ row.total }}{{ row.unit == 'percent' ? '%' : '' }}</span>
                                            <span v-if="row.unit == 'euros'">{{ currency(row.total) }}</span>
                                        </span>
                                    </td>
                                </tr>

                                <tr class="ix-table-row-secondary text-center" v-if="filteredTable(groupBy.spending).length > 0 && showRowIndicator(filteredTable(groupBy.spending)[0])">
                                    <th :colspan="table.header.length + 3" @click="showGroup.spending = !showGroup.spending"  class="ix-row-header">
                                        Dépense
                                        <span class="text-right ml-2">
                                                <i class="fas fa-chevron-down" v-if="showGroup.spending"></i>
                                                <i class="fas fa-chevron-up" v-if="!showGroup.spending"></i>
                                        </span>
                                    </th>
                                </tr>
                                <tr v-for="(row, index) in table.rows" v-bind:key="index" v-if="showRowIndicator(row) && showGroup.spending && row.group == groupBy.spending">
                                    <td>
                                        {{ row.label }}
                                        <br>
                                        <small v-if="filters.show_description">
                                            {{ row.description }}
                                        </small>
                                    </td>
                                    <td v-for="(head, index) in table.header" v-bind:key="index" class="text-center">
                                        <span v-if="row.data[head.index] != null">
                                        
                                            <span v-if="row.unit != 'euros'">{{ row.data[head.index] }}{{ row.unit == 'percent' ? '%' : '' }}</span>
                                            <span v-if="row.unit == 'euros'">{{ currency(row.data[head.index]) }}</span>
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <span v-if="row.total != null">
                                            <span v-if="row.unit != 'euros'">{{ row.total }}{{ row.unit == 'percent' ? '%' : '' }}</span>
                                            <span v-if="row.unit == 'euros'">{{ currency(row.total) }}</span>
                                        </span>
                                    </td>
                                </tr>
                                <tr class="ix-table-row-secondary text-center" v-if="filteredTable(groupBy.bank).length > 0 && showRowIndicator(filteredTable(groupBy.bank)[0])">
                                    <th :colspan="table.header.length + 3" @click="showGroup.bank = !showGroup.bank"  class="ix-row-header">
                                        Comptabilité
                                        <span class="text-right ml-2">
                                                <i class="fas fa-chevron-down" v-if="showGroup.bank"></i>
                                                <i class="fas fa-chevron-up" v-if="!showGroup.bank"></i>
                                        </span>
                                    </th>
                                </tr>
                                <tr v-for="(row, index) in table.rows"  v-bind:key="index" v-if="showRowIndicator(row) && showGroup.bank && row.group == groupBy.bank">
                                    <td>
                                        {{ row.label }}
                                        <br>
                                        <small v-if="filters.show_description">
                                            {{ row.description }}
                                        </small>
                                    </td>
                                    <td v-for="(head, index) in table.header" v-bind:key="index" class="text-center">
                                        <span v-if="row.data[head.index] != null">
                                        
                                            <span v-if="row.unit != 'euros'">{{ row.data[head.index] }}{{ row.unit == 'percent' ? '%' : '' }}</span>
                                            <span v-if="row.unit == 'euros'">{{ currency(row.data[head.index]) }}</span>
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <span v-if="row.total != null">
                                            <span v-if="row.unit != 'euros'">{{ row.total }}{{ row.unit == 'percent' ? '%' : '' }}</span>
                                            <span v-if="row.unit == 'euros'">{{ currency(row.total) }}</span>
                                        </span>
                                    </td>
                                </tr>
                                <tr class="ix-table-row-secondary text-center" v-if="filteredTable(groupBy.hr).length > 0 && showRowIndicator(filteredTable(groupBy.hr)[0])">
                                    <th :colspan="table.header.length + 3" @click="showGroup.hr = !showGroup.hr" class="ix-row-header">
                                        RH
                                        <span class="text-right ml-2">
                                                <i class="fas fa-chevron-down" v-if="showGroup.hr"></i>
                                                <i class="fas fa-chevron-up" v-if="!showGroup.hr"></i>
                                        </span>
                                    </th>
                                </tr>
                                <tr v-for="(row, index) in table.rows" v-bind:key="index" v-if="showRowIndicator(row) && showGroup.hr && row.group == groupBy.hr">
                                    <td>
                                        {{ row.label }}
                                        <br>
                                        <small v-if="filters.show_description">
                                            {{ row.description }}
                                        </small>
                                    </td>
                                    <td v-for="(head, index) in table.header" v-bind:key="index" class="text-center">
                                        <span v-if="row.data[head.index] != null">
                                        
                                            <span v-if="row.unit != 'euros'">{{ row.data[head.index] }}{{ row.unit == 'percent' ? '%' : '' }}</span>
                                            <span v-if="row.unit == 'euros'">{{ currency(row.data[head.index]) }}</span>
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <span v-if="row.total != null">
                                            <span v-if="row.unit != 'euros'">{{ row.total }}{{ row.unit == 'percent' ? '%' : '' }}</span>
                                            <span v-if="row.unit == 'euros'">{{ currency(row.total) }}</span>
                                        </span>
                                    </td>
                                </tr>
                                <tr class="ix-table-row-secondary text-center" v-if="filteredTable(groupBy.qse).length > 0 && showRowIndicator(filteredTable(groupBy.qse)[0])">
                                    <th :colspan="table.header.length + 3" @click="showGroup.qse = !showGroup.qse" class="ix-row-header">
                                        QSE
                                        <span class="text-right ml-2">
                                                <i class="fas fa-chevron-down" v-if="showGroup.qse"></i>
                                                <i class="fas fa-chevron-up" v-if="!showGroup.qse"></i>
                                        </span>
                                    </th>
                                </tr>
                                <tr v-for="(row, index) in table.rows" v-bind:key="index" v-if="showRowIndicator(row) && showGroup.qse && row.group == groupBy.qse">
                                    <td>
                                        {{ row.label }}
                                        <br>
                                        <small v-if="filters.show_description">
                                            {{ row.description }}
                                        </small>
                                    </td>
                                    <td v-for="(head, index) in table.header" v-bind:key="index" class="text-center">
                                        <span v-if="row.data[head.index] != null">
                                        
                                            <span v-if="row.unit != 'euros'">{{ row.data[head.index] }}{{ row.unit == 'percent' ? '%' : '' }}</span>
                                            <span v-if="row.unit == 'euros'">{{ currency(row.data[head.index]) }}</span>
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <span v-if="row.total != null">
                                            <span v-if="row.unit != 'euros'">{{ row.total }}{{ row.unit == 'percent' ? '%' : '' }}</span>
                                            <span v-if="row.unit == 'euros'">{{ currency(row.total) }}</span>
                                        </span>
                                    </td>
                                </tr>
                                <tr class="ix-table-row-secondary text-center" v-if="filteredTable(groupBy.stock).length > 0 && showRowIndicator(filteredTable(groupBy.stock)[0])">
                                    <th :colspan="table.header.length + 3" @click="showGroup.stock = !showGroup.stock"  class="ix-row-header">
                                        Stock
                                        <span class="text-right ml-2">
                                                <i class="fas fa-chevron-down" v-if="showGroup.stock"></i>
                                                <i class="fas fa-chevron-up" v-if="!showGroup.stock"></i>
                                        </span>
                                    </th>
                                </tr>
                                <tr v-for="(row, index) in table.rows" v-bind:key="index"  v-if="showRowIndicator(row) && showGroup.stock && row.group == groupBy.stock">
                                    <td>
                                        {{ row.label }}
                                        <br>
                                        <small v-if="filters.show_description">
                                            {{ row.description }}
                                        </small>
                                    </td>
                                    <td v-for="(head, index) in table.header" v-bind:key="index" class="text-center">
                                        <span v-if="row.data[head.index] != null">
                                        
                                            <span v-if="row.unit != 'euros'">{{ row.data[head.index] }}{{ row.unit == 'percent' ? '%' : '' }}</span>
                                            <span v-if="row.unit == 'euros'">{{ currency(row.data[head.index]) }}</span>
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <span v-if="row.total != null">
                                            <span v-if="row.unit != 'euros'">{{ row.total }}{{ row.unit == 'percent' ? '%' : '' }}</span>
                                            <span v-if="row.unit == 'euros'">{{ currency(row.total) }}</span>
                                        </span>
                                    </td>
                                </tr>
                                <tr class="no-borders" v-if="filters.view == 'y' && canManageIndicator && !loadingIndicator">
   
                                    <td  class="no-borders">Consolidation des calculs</td>
                                    <td v-for="(head, index) in table.header" v-bind:key="index" class="text-center no-borders">
                                        <button type="button" v-if="(table.header[index - 1] && table.header[index - 1].closed) || head.closed || (index == 0 && !head.closed)" class="ix-btn btn-sm" style="width: 30px !important; height: 30px !important; padding: 0px !important" @click="closeIndicators(head)" v-bind:class="{'blue' : !head.closed}" data-toggle="tooltip" data-placement="top" :title="head.closed ? 'Déverrouiller' : 'Verrouiller'">
                                                <i v-if="head.closed"  class="fas fa-lock" style="margin-right: 0px !important"></i>
                                                <i v-if="!head.closed"  class="fas fa-unlock" style="margin-right: 0px !important"></i>
                                               
                                        </button>
                                        <div v-if="head.closed_at">
                                            {{ head.closed_at }}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr v-if="table.rows.length == 0 && !loadingSettings && !loadingIndicator">
                                    <td colspan="100%" class="text-center">
                                        <button class="ix-btn link" @click="openIndicatorSelectionModal()">
                                            Veuillez choisir des indicateurs à afficher
                                        </button>
                                    </td>
                                </tr>
                                <tr v-if="loadingSettings || loadingIndicator">
                                    <td colspan="100%" class="text-center">
                                        <i class="far fa-circle-notch fa-spin"></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="indicatorSelectionModal" tabindex="-1" aria-labelledby="indicatorSelectionModal" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Indicateurs disponibles</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="filters_show_description" v-model="filters.show_description">
                                <label class="form-check-label" for="filters_show_description">Afficher la description des indicateurs</label>
                            </div>
                        </div>

                        <div class="ix-table-box">
                            <table class="ix-table ix-table-sm ix-table-hoverable">
                                 <thead>
                                    <tr>
                                        <th>Indicateur</th>
                                        <th class="text-center">Afficher</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                 <tbody>
                                     <template v-if="filteredIndicators(groupBy.crm).length > 0">
                                        <tr class="ix-table-row-secondary">
                                            <th>CRM</th>
                                            <td class="text-center">
                                                <input  type="checkbox" @change="selectAllIndicator(groupBy.crm)" v-model="display.crm">
                                            </td>
                                             <td class="text-right" @click="showGroup.crm = !showGroup.crm" style="cursor: pointer">
                                                  <span class="text-right">
                                                        <i class="fas fa-chevron-down" v-if="showGroup.crm"></i>
                                                        <i class="fas fa-chevron-up" v-if="!showGroup.crm"></i>
                                                    </span>
                                             </td>
                                        </tr>
                                        <tr v-for="(indicator, crm) in filteredIndicators(groupBy.crm)" v-bind:key="indicator.label" v-show="showGroup.crm">
                                            <td>
                                                <label :for="'indicator' + indicator.label" class="m-0">{{ indicator.label }}</label>
                                                <span class="d-block ix-text-small ix-text-secondary" v-if="indicator.description && filters.show_description">{{ indicator.description }}</span>
                                            </td>
                                            <td class="text-center">
                                                <input type="checkbox" v-model="indicator.is_displayed" :id="'indicator' + indicator.label" @change="selectIndicator(indicator)" :disabled="loadingIndicator">
                                            </td>
                                        </tr>
                                     </template>
                                     <template  v-if="filteredIndicators(groupBy.activity).length > 0">
                                        <tr class="ix-table-row-secondary">
                                             <th>Activité</th>
                                            <td class="text-center">
                                                <input  type="checkbox" @change="selectAllIndicator(groupBy.activity)" v-model="display.activity">
                                            </td>
                                              <td class="text-right" @click="showGroup.activity = !showGroup.activity" style="cursor: pointer">
                                                  <span class="text-righ">
                                                        <i class="fas fa-chevron-down" v-if="showGroup.activity"></i>
                                                        <i class="fas fa-chevron-up" v-if="!showGroup.activity"></i>
                                                    </span>
                                             </td>
                                        </tr>
                                        <tr v-for="(indicator, activity) in filteredIndicators(groupBy.activity)" v-bind:key="indicator.label" v-show="showGroup.activity">
                                            <td>
                                                <label :for="'indicator' + indicator.label" class="m-0">{{ indicator.label }}</label>
                                                <span class="d-block ix-text-small ix-text-secondary" v-if="indicator.description && filters.show_description">{{ indicator.description }}</span>
                                            </td>
                                            <td class="text-center">
                                                <input type="checkbox" v-model="indicator.is_displayed" :id="'indicator' + indicator.label" @change="selectIndicator(indicator)" :disabled="loadingIndicator">
                                            </td>
                                        </tr>
                                     </template>
                                     <template v-if="filteredIndicators(groupBy.trade).length > 0">
                                        <tr class="ix-table-row-secondary">
                                            <th>Commerce</th>
                                            <td class="text-center">
                                                <input  type="checkbox" @change="selectAllIndicator(groupBy.trade)" v-model="display.trade">
                                            </td>
                                              <td class="text-right" @click="showGroup.trade = !showGroup.trade" style="cursor: pointer">
                                                  <span class="text-right ml-2">
                                                        <i class="fas fa-chevron-down" v-if="showGroup.trade"></i>
                                                        <i class="fas fa-chevron-up" v-if="!showGroup.trade"></i>
                                                    </span>
                                             </td>
                                        </tr>
                                        <tr v-for="(indicator, trade) in filteredIndicators(groupBy.trade)" v-bind:key="indicator.label" v-show="showGroup.trade">
                                            <td>
                                                <label :for="'indicator' + indicator.label" class="m-0">{{ indicator.label }}</label>
                                                <span class="d-block ix-text-small ix-text-secondary" v-if="indicator.description && filters.show_description">{{ indicator.description }}</span>
                                            </td>
                                            <td class="text-center">
                                                <input type="checkbox" v-model="indicator.is_displayed" :id="'indicator' + indicator.label" @change="selectIndicator(indicator)" :disabled="loadingIndicator">
                                            </td>
                                        </tr>
                                     </template>
                                     <template v-if="filteredIndicators(groupBy.spending).length > 0">
                                        <tr class="ix-table-row-secondary">
                                            <th>Dépense</th>
                                            <td class="text-center">
                                                <input  type="checkbox" @change="selectAllIndicator(groupBy.spending)" v-model="display.spending"/>
                                            </td>
                                              <td class="text-right" @click="showGroup.spending = !showGroup.spending" style="cursor: pointer" >
                                                  <span class="text-right ml-2">
                                                        <i class="fas fa-chevron-down" v-if="showGroup.spending"></i>
                                                        <i class="fas fa-chevron-up" v-if="!showGroup.spending"></i>
                                                    </span>
                                             </td>
                                        </tr>
                                        <tr v-for="(indicator, spending) in filteredIndicators(groupBy.spending)" v-bind:key="indicator.label" v-show="showGroup.spending">
                                            <td>
                                                <label :for="'indicator' + indicator.label" class="m-0">{{ indicator.label }}</label>
                                                <span class="d-block ix-text-small ix-text-secondary" v-if="indicator.description && filters.show_description">{{ indicator.description }}</span>
                                            </td>
                                            <td class="text-center">
                                                <input type="checkbox" v-model="indicator.is_displayed" :id="'indicator' + indicator.label" @change="selectIndicator(indicator)" :disabled="loadingIndicator">
                                            </td>
                                        </tr>
                                     </template>
                                     <template v-if="filteredIndicators(groupBy.bank).length > 0">
                                        <tr class="ix-table-row-secondary">
                                             <th>Comptabilité</th>
                                            <td class="text-center">
                                                <input  type="checkbox" @change="selectAllIndicator(groupBy.bank)" v-model="display.bank">
                                            </td>
                                              <td class="text-right" @click="showGroup.bank = !showGroup.bank" style="cursor: pointer">
                                                  <span class="text-right ml-2">
                                                        <i class="fas fa-chevron-down" v-if="showGroup.bank"></i>
                                                        <i class="fas fa-chevron-up" v-if="!showGroup.bank"></i>
                                                    </span>
                                             </td>
                                        </tr>
                                        <tr v-for="(indicator, bank) in filteredIndicators(groupBy.bank)" v-bind:key="indicator.label" v-show="showGroup.bank">
                                            <td>
                                                <label :for="'indicator' + indicator.label" class="m-0">{{ indicator.label }}</label>
                                                <span class="d-block ix-text-small ix-text-secondary" v-if="indicator.description && filters.show_description">{{ indicator.description }}</span>
                                            </td>
                                            <td class="text-center">
                                                <input type="checkbox" v-model="indicator.is_displayed" :id="'indicator' + indicator.label" @change="selectIndicator(indicator)" :disabled="loadingIndicator">
                                            </td>
                                        </tr>
                                     </template>
                                      <template v-if="filteredIndicators(groupBy.hr).length > 0">
                                        <tr class="ix-table-row-secondary">
                                             <th>RH</th>
                                            <td class="text-center">
                                                <input  type="checkbox" @change="selectAllIndicator(groupBy.hr)" v-model="display.hr">
                                            </td>
                                              <td class="text-right" @click="showGroup.hr = !showGroup.hr" style="cursor: pointer">
                                                  <span class="text-right ml-2">
                                                        <i class="fas fa-chevron-down" v-if="showGroup.hr"></i>
                                                        <i class="fas fa-chevron-up" v-if="!showGroup.hr"></i>
                                                    </span>
                                             </td>
                                        </tr>
                                        
                                        <tr v-for="(indicator, hr) in filteredIndicators(groupBy.hr)" v-bind:key="indicator.label" v-show="showGroup.hr">
                                            <td>
                                                <label :for="'indicator' + indicator.label" class="m-0">{{ indicator.label }}</label>
                                                <span class="d-block ix-text-small ix-text-secondary" v-if="indicator.description && filters.show_description">{{ indicator.description }}</span>
                                            </td>
                                            <td class="text-center">
                                                <input type="checkbox" v-model="indicator.is_displayed" :id="'indicator' + indicator.label" @change="selectIndicator(indicator)" :disabled="loadingIndicator">
                                            </td>
                                        </tr>
                                     </template>
                                      <template v-if="filteredIndicators(groupBy.qse).length > 0">
                                        <tr class="ix-table-row-secondary">
                                         <th>QSE</th>
                                        <td class="text-center">
                                                <input  type="checkbox" @change="selectAllIndicator(groupBy.qse)" v-model="display.qse">
                                        </td>
                                        <td class="text-right" @click="showGroup.qse = !showGroup.qse" style="cursor: pointer">
                                                <span class="text-right ml-2">
                                                    <i class="fas fa-chevron-down" v-if="showGroup.qse"></i>
                                                    <i class="fas fa-chevron-up" v-if="!showGroup.qse"></i>
                                                </span>
                                        </td>
                                        </tr>
                                        <tr v-for="(indicator, qse) in filteredIndicators(groupBy.qse)" v-bind:key="indicator.label" v-show="showGroup.qse">
                                            <td>
                                                <label :for="'indicator' + indicator.label" class="m-0">{{ indicator.label }}</label>
                                                <span class="d-block ix-text-small ix-text-secondary" v-if="indicator.description && filters.show_description">{{ indicator.description }}</span>
                                            </td>
                                            <td class="text-center">
                                                <input type="checkbox" v-model="indicator.is_displayed" :id="'indicator' + indicator.label" @change="selectIndicator(indicator)" :disabled="loadingIndicator">
                                            </td>
                                        </tr>
                                     </template>
                                      <template v-if="filteredIndicators(groupBy.stock).length > 0">
                                        <tr class="ix-table-row-secondary">
                                             <th>Stock</th>
                                            <td class="text-center">
                                                <input  type="checkbox" @change="selectAllIndicator(groupBy.stock)" v-model="display.stock">
                                            </td>
                                              <td class="text-right" @click="showGroup.stock = !showGroup.stock" style="cursor: pointer">
                                                  <span class="text-right ml-2">
                                                        <i class="fas fa-chevron-down" v-if="showGroup.stock"></i>
                                                        <i class="fas fa-chevron-up" v-if="!showGroup.stock"></i>
                                                    </span>
                                             </td>
                                        </tr>
                                        <tr v-for="(indicator, bank) in filteredIndicators(groupBy.stock)" v-bind:key="indicator.label" v-show="showGroup.stock">
                                            <td>
                                                <label :for="'indicator' + indicator.label" class="m-0">{{ indicator.label }}</label>
                                                <span class="d-block ix-text-small ix-text-secondary" v-if="indicator.description && filters.show_description">{{ indicator.description }}</span>
                                            </td>
                                            <td class="text-center">
                                                <input type="checkbox" v-model="indicator.is_displayed" :id="'indicator' + indicator.label" @change="selectIndicator(indicator)" :disabled="loadingIndicator">
                                            </td>
                                        </tr>
                                     </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    import draggable from 'vuedraggable';
    import * as moment from 'moment'

    export default {
        name: "indicators-array",
        props: ['settingsData', 'settingsRoute', 'computeRoute', 'downloadRoute', 'preferencesRoute', 'closeRoute', 'canManageIndicator', 'exportRoute', 'exportExcelRoute'],
        components : {
            draggable
        },
        data() {
            return {
                loadingSettings: false,
                loadingIndicator: false,
                loadingDownload: false,
                loadingPreferences: false,
                loadingTxt: false,
                loadingClose: null,
                filters: {
                    views: [
                        {label: 'Annuel', value: 'y'},
                        {label: 'Hebdomadaire', value: 'w'},
                    ],
                    years: [],
                    view: 'y',
                    year: '',
                    week: '',

                    indicators: [],
                    search: '',
                    show_description: false,

                    start: '',
                    end: ''
                },
                table: {
                    header: [],
                    rows: [],
                },
                closeMessage: null,
                closedIndicators: [],
                decemberClosed: false,
                nbIndicators: 0,
                groupBy : {
                    crm : 1,
                    activity: 2,
                    trade: 3,
                    spending: 4,
                    bank: 5,
                    hr: 6,
                    qse: 7,
                    stock: 8
                },
                showGroup : {
                    crm : true,
                    activity: true,
                    trade: true,
                    spending: true,
                    bank: true,
                    hr: true,
                    qse: true,
                    stock: true
                },
                display : {
                    crm: false,
                    activity: false,
                    trade: false,
                    spending: false,
                    bank: false,
                    hr: false,
                    qse: false,
                    stock: false
                }
            }
        },
        computed: {
            /*filteredIndicators: function () {
                return this.filters.indicators.filter((indicator) => {
                    return indicator.label.toLowerCase().includes(this.filters.search)
                })
            }*/
        },
        methods : {
            checkMove: function(evt){
                return (evt.draggedContext.element) != undefined ? true : false
            },
            openIndicatorSelectionModal(index) {
                $('#indicatorSelectionModal').modal()
            },
            filteredIndicators: function(groupBy){
                let filterIndicators =  this.filters.indicators.filter((indicator) => {
                    return indicator.group === groupBy;
                })
                return _.orderBy(filterIndicators, ['value'], ['asc']);
            },
            filteredTable: function(groupBy){
                return this.table.rows.filter((row) => {
                    if(row != undefined)
                        return row.group === groupBy;
                });
            },
            selectIndicator: function(indicator) {
                if (indicator.is_displayed == false) {
                    // Suppression de l'indicateur du tableau
                    var currentIndicatorPosition = this.table.rows.findIndex(row => {
                        return row.indicator == indicator.value
                    })

                    if (currentIndicatorPosition >= 0) {
                        this.table.rows.splice(currentIndicatorPosition, 1)
                    }
                } else {
                    this.getIndicators([indicator.value])
                }
            },
            selectAllIndicator(group){
                let display = false;
                switch(group){      
                    case this.groupBy.crm:
                        display = this.display.crm;
                        break;
                    case this.groupBy.activity: 
                        display = this.display.activity;
                        break;
                    case this.groupBy.trade:
                        display = this.display.trade;
                        break;
                    case this.groupBy.spending:
                        display = this.display.spending;
                        break;    
                    case this.groupBy.bank:
                        display = this.display.bank;
                        break;
                    case this.groupBy.hr: 
                        display = this.display.hr;
                        break;
                    case this.groupBy.qse:
                        display = this.display.qse;
                        break;
                    case this.groupBy.stock:
                        display = this.display.stock;
                        break;         
                }
                this.loadingIndicator = true;
                let indicators = this.filteredIndicators(group);


                indicators.forEach((indicator,index) => {
                    indicators[index].is_displayed = display;
                    var currentIndicatorPosition = this.table.rows.findIndex(row => {
                        return row.indicator == indicators[index].value
                    })
                    
                    if (currentIndicatorPosition === -1 && indicators[index].is_displayed) {
                         this.getIndicators([indicator.value])
                    } else {
                        if (currentIndicatorPosition >= 0 &&  !indicators[index].is_displayed) {
                            this.table.rows.splice(currentIndicatorPosition, 1)
                        }
                    }
                })

                this.loadingIndicator = false;
            },
            groupSelected(group){
                let indicators = this.filteredIndicators(group).map(function(indic){
                    return indic.is_displayed ? indic.is_displayed : false;
                });

                return indicators.find(elem => elem == false) == undefined ? true : false;
            },
            viewFilterChanged: function(){
                this.setTable()
            },
            yearFilterChanged: function(){
                if (this.filters.year.max_week == 52 && this.filters.week == 53) {
                    this.filters.week = 52
                }

                this.setTable()
            },
            weekFilterChanged: function(){
                this.setTable()
            },
            getCurrentIndicators: function () {
                return this.table.rows.map(function(row) {
                    return row.indicator
                })
            },
            setTable: async function (indicatorsPreferences = null) {
                this.table.header = []

                // Récupération des indicateurs actuellement affichés pour mise à jour ultérieure
                var currentIndicators = this.getCurrentIndicators();

                if (indicatorsPreferences && indicatorsPreferences.length) {
                    currentIndicators = indicatorsPreferences
                }

                this.table.rows = []

                this.loadingSettings = true;
                fetch(this.settingsRoute + "?view=" + this.filters.view + "&year=" + this.filters.year.year + (this.filters.view == 'w' ? "&week=" + this.filters.week : ""), {
                    ...{
                        method: 'GET',
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    
                    this.table.header = data.header
                    this.filters.start = data.start
                    this.filters.end = data.end

                    this.loadingSettings = false

                    // Mise à jour des indicateurs précédemment affichés
                    if (currentIndicators.length > 0) {
                        this.getIndicators(currentIndicators)
                    }
                }).catch(error => {
                    this.loadingSettings = false
                    console.log(error)
                });
            },
            getIndicators: async function (indicators) {
                this.loadingIndicator = true;
                fetch(this.computeRoute + "?view=" + this.filters.view + "&start=" + this.filters.start + "&end=" + this.filters.end + "&indicators=" + indicators.join(';'), {
                    ...{
                        method: 'GET',
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    data['rows'].forEach(row => {
                        this.table.rows.push(row)
                        //this.closedIndicators = row.data;
                        //console.log(this.closedIndicators, row);
                    });
                    this.decemberClosed = data['decemberIsClosed'];
                    this.nbIndicators = data['nbIndicators'];

                    this.loadingIndicator = false

                    this.table.rows = _.orderBy(this.table.rows, ['indicator'], ['asc']);
                }).catch(error => {
                    this.loadingIndicator = false
                    console.log(error)
                });
            },
            showRowIndicator(row){
                var show = true;
                    if(this.filters.view == 'w' && row != undefined)
                        show = !row.displayOnlyYear;

                return show;
            },
            monthCanBeClosed(date){
                var dateColumn = moment(date, "MM/YYYY").endOf('month');
                var today = moment();

                return today.isSameOrAfter(dateColumn);
            },
            closeIndicators: async function(date){
                this.loadingClose = date.index;
                this.loadingIndicator = true;

                fetch(this.closeRoute+"?date=" + date.index, {
                     ...this.getHttpJsonRequestHeaders(),
                     ...{
                        method : "POST",
    
                    }
                }).then((response) => {
                    if(response.status == 200){
                        this.closeMessage = 'Le calcul des indicateurs a bien été réalisé sur la période du : ' + date.index;
                    } 
                    this.loadingClose = null;
                    this.loadingIndicator = false;
                    this.setTable();
                }).catch(error => {
                    this.loadingClose = null;
                    this.closeMessage = null;
                    this.loadingIndicator = false;
                })
            },
            download: async function () {
                this.loadingDownload = true
                fetch(this.downloadRoute, {
                    ...this.getHttpJsonRequestHeaders(),
                    ...{
                        method : "POST",
                        body :  JSON.stringify({
                            data : this.table
                        })
                    }
                }).then((response) => {
                    this.loadingDownload = false;
                    if (response.ok) {
                        return response.blob();
                    } else {
                        throw new Error("Bad server response");
                    }
                }).then((data) => {
                    var url = window.URL.createObjectURL(data);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = 'indicateurs.pdf';
                    document.body.appendChild(a);
                    a.setAttribute('style', 'display: none');
                    
                    a.click();
                    window.URL.revokeObjectURL(url);
                    a.remove();
                })
                .catch(error=> {
                    this.loadingDownload = false;
                    console.log(error);
                })
            },
            downloadIndicator: async function(title = null){
                console.log(this.exportRoute);
                this.loadingTxt = true
                fetch(this.exportRoute + "?start=" + this.filters.start + "&end=" + this.filters.end, {
                    ...this.getHttpJsonRequestHeaders(),
                    ...{
                        method : "GET",
                    }
                }).then((response) => {
                    this.loadingTxt = false;
                    if (response.ok) {
                        return response.blob();
                    } else {
                        throw new Error("Bad server response");
                    }
                }).then((data) => {
                    var url = window.URL.createObjectURL(data);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = title;
                    document.body.appendChild(a);
                    a.setAttribute('style', 'display: none');
                    
                    a.click();
                    window.URL.revokeObjectURL(url);
                    a.remove();
                })
                .catch(error=> {
                    this.loadingTxt = false;
                    console.log(error);
                });
            },
            exportExcelIndicator(){
                fetch(this.exportExcelRoute + "?start=" + this.filters.start + "&end=" + this.filters.end, {
                    ...this.getHttpJsonRequestHeaders(),
                    ...{
                        method : "GET",
                    }
                }).then((response) => {
                    this.loadingTxt = false;
                    if (response.ok) {
                        return response.blob();
                    } else {
                        throw new Error("Bad server response");
                    }
                }).then((data) => {
                    var url = window.URL.createObjectURL(data);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = 'indicateurs' + this.moment();
                    document.body.appendChild(a);
                    a.setAttribute('style', 'display: none');
                    
                    a.click();
                    window.URL.revokeObjectURL(url);
                    a.remove();
                })
                .catch(error=> {
                    this.loadingTxt = false;
                    console.log(error);
                });
            },
            savePreferences: async function () {
                this.loadingPreferences = true
                var data = this.getCurrentIndicators().join(',')
                
                fetch(this.preferencesRoute, {
                    ...{
                        method: 'PUT',
                        body:  JSON.stringify({indicators: data})
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    this.loadingPreferences = false
                }).catch(error=> {
                    this.loadingPreferences = false
                    console.log(error);
                })
            }
        },
        async mounted(){
            const settings = JSON.parse(this.settingsData)

            this.filters.indicators = settings.indicators
            this.filters.years = settings.years

            var today = this.moment()
            this.filters.week = today.format('W')
            var currentYear = today.format('YYYY')

            var currentYearIndex = this.filters.years.findIndex(year => {
                return year.year == currentYear
            })

            if (currentYearIndex >= 0) {
                this.filters.year = this.filters.years[currentYearIndex]
            }

            this.setTable(settings.indicators_preferences)

            // Selection des indicateurs dans la modal en cas de préférences
            if (settings.indicators_preferences.length) {
                settings.indicators_preferences.forEach(indicatorValue => {
                    var index = this.filters.indicators.findIndex((indicator) => {
                        return indicator.value == indicatorValue
                    })

                    if (index >= 0) {
                        this.filters.indicators[index].is_displayed = true
                    }
                });
            }
        }
    }
</script>

<style>
.no-borders {
    border : 0px solid var(--ix-border-secondary) !important;
    padding: 10px !important;
}

.ix-row-header {
    padding: 10px !important;
    cursor: pointer;
    font-size: 16px !important;
}

.ix-table-row-secondary{
    background: #f6f8fa;
}

tr {
    border: 1px solid #EAECEF !important;
    border-bottom: 1px solid #EAECEF!important;
}

</style>
